module.exports = __webpack_public_path__ + "img/basic _ circle_check_outline@2x.33036da7.png";